export enum TasksTypesNames {
  hw_mob_login = 'Install the Headway app',
  ct_copy = 'Follow a strategy in Headway Copytrade',
  nova_token = 'Buy a Headway NOVA token',
  trustpilot_review = 'Leave a review on TrustPilot',
  store_review = 'Leave a review in Google Play or AppStore',
  facebook_x_insta_post = 'Post on your Facebook / Instagram',
}

export const PRIZE_TYPES = {
  toyota: 'Toyota Hilux Double Cab 2.4',
  yamaha: 'Yamaha X Max',
  gold_100: 'Gold 100g',
  iphone_17: 'iPhone 17 Pro MAX',
  samsung_s26: 'Samsung Galaxy S26 Ultra',
  usd_333: '333 USD',
  apple_watch: 'Apple Watch Series 9',
  samsung_galaxy_watch: 'Samsung Galaxy Watch 8',
  samsung_galaxy_a55: 'Samsung Galaxy A55',
  usd_33: '33 USD',
  usd_5: '5 USD',
  giftshop_crowns_5: '5 Giftshop Crowns',
} as const

export const prizeTypesOptions = Object.entries(PRIZE_TYPES).map(
  ([key, value]) => ({
    label: value,
    value: key as keyof typeof PRIZE_TYPES,
  }),
)
